<template>
  <div class="list">
    <div
      v-for="item of events"
      :key="item.id"
      class="item"
      :class="{ itemActive: isActive(item), past: isPastEvent(item) }"
      @click="$emit('select', [item.date_start, item.date_end], null, null, isActive(item) ? {} : item)"
    >
      <bim-text type=medium bold class="mb-1 d-flex date">
        <div class="check mr-2" v-html="require('@/assets/img/icon-saved-small-neon.svg')"></div>
        <span>{{ localeDate(item.date_start) }}</span>
        <span v-if="showLast(item)" class="ml-1">— {{ localeDate(item.date_end) }}</span>
      </bim-text>
      <bim-text type=medium class="title">{{ item.title }}</bim-text>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    active: Array,
    events: Array,
    language: String,
    activeEvent: Object
  },
  data() {
    return {
      today: new Date()
    }
  },
  methods: {
    localeDate(date) {
      return new Date(date).toLocaleDateString(this.language, {
        day: '2-digit',
        month: 'long',
      })
    },
    isActive(item) {
      return this.activeEvent && item.id === this.activeEvent.id
    },
    isPastEvent(item) {
      return item.date_end.getTime() <= this.today.getTime()
    },
    showLast(item) {
      return item.date_start.setHours(0, 0, 0, 0) !== item.date_end.setHours(0, 0, 0, 0)
    }
  }
}
</script>

<style lang="scss" scoped>
.list {
  max-height: 321px;
  overflow: auto;
  .item {
    cursor: pointer;
    padding-bottom: 14px;
    margin-bottom: 14px;
    border-bottom: 1px solid #e6e6e6;

    .check {
      display: none;
    }

    &.past {
      opacity: .75;
      .check {
        display: block;
      }
    }

    &.itemActive {
      .date {
        color: $primary-color;
      }
    }

    .date {
      line-height: 1.36;
      letter-spacing: normal;
    }

    .title {
      line-height: 1.57;
      letter-spacing: 0.2px;
    }

    .date, .title {
      color: #4d4d4d;
    }
  }
}
</style>
